var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-window"},[_c('div',{staticClass:"overlay__frame"},[_c('WFBrowser',{attrs:{"src":_vm.url,"resetPage":false}}),_c('div',{staticClass:"tab-button close",attrs:{"data-translation-element":"close"},on:{"click":function($event){return _vm.close()}}},[_vm._v("Close")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }